import React from "react";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import StackedBarChartIcon from "@mui/icons-material/StackedBarChart";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
import IconButton from "@mui/material/IconButton";
import VisualButtonModal from "./VisualButtonModal";
import ListAltIcon from "@mui/icons-material/ListAlt";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import Tooltip from "@mui/material/Tooltip";
import VisualChartModal from "./VisualChartModal";
import TableViewIcon from "@mui/icons-material/TableView";
import VisualDailyReportModal2 from "./VisualDailyReportModal2";
import GuestReviewOverlayModal from "./GuestReviewOverlayModal";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import { generateLaborSummary, get_t_str } from "../../../../helpers/helpers";

function VisualButtonOptions2(props) {
  const [openChart, setOpenChart] = React.useState(false);
  const handleOpenChart = () => setOpenChart(true);
  const handleCloseChart = () => setOpenChart(false);

  React.useEffect(() => {
    setOpenChart(false);
  }, [props.date_str, props.store_id, props.laborModelEnabled, props.modelDataAvailable]);

  const isToday = React.useMemo(() => {
    if (!props.date_str) {
      return false;
    }
    const today = new Date();
    const month = `${today.getMonth() + 1}`.padStart(2, "0");
    const day = `${today.getDate()}`.padStart(2, "0");
    const todayStr = `${today.getFullYear()}-${month}-${day}`;
    return todayStr === props.date_str;
  }, [props.date_str]);

  const isScheduleEmpty = props.actual_schedule_labor_day.length === 0 && props.forecasted_labor_day?.length === 0;
  const hasNoMetricsData =
    props.actual_used_labor_vs_earned_day?.length === 0 &&
    props.calculated_earned_labor_day?.length === 0;
  const disableMetricsButtons =
    (!props.checkedMetricsToggle && isScheduleEmpty) ||
    (props.checkedMetricsToggle && !isToday && hasNoMetricsData);

  const [openDailyReport2, setOpenDailyReport2] = React.useState(false);
  const handleOpenDailyReport2 = () => setOpenDailyReport2(true);
  const handleCloseDailyReport2 = () => setOpenDailyReport2(false);

  const [openGuestReview, setOpenGuestReview] = React.useState(false);
  const handleOpenGuestReview = () => setOpenGuestReview(true);
  const handleCloseGuestReview = () => setOpenGuestReview(false);


  const clickChartButton = () => {
    handleOpenChart();
  };

  const clickDailyReportButton2 = () => {
    handleOpenDailyReport2();
  };

  const clickGuestReviewButton = () => {
    handleOpenGuestReview();
  };

  // Live Action is a tab, not a modal: the task drawer and its dialogs sit
  // under a modal's backdrop, so the button goes to the tab instead.
  const clickLiveDayLaborButton = () => {
    props.openLiveAction?.();
  };

  const iconButtonSx = {
    width: 28,
    height: 28,
    borderRadius: "6px",
    color: "#64748b",
    "&:hover": { backgroundColor: "#f1f5f9", color: "#334155" },
  };

  return (
    <div>
      <div className="w-full flex items-center justify-center gap-1">
        {props.laborModelEnabled && (
          <Tooltip title="Intraday Staffing Levels Expanded">
            <IconButton
              size="small"
              sx={iconButtonSx}
              disabled={disableMetricsButtons || props.modelDataAvailable === false}
              onClick={() => clickChartButton("Intraday Graph")}
            >
              <StackedLineChartIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        {props.liveLaborEnabled && isToday && props.checkedMetricsToggle ? (
          <Tooltip title="Live Action Report">
            <IconButton
              size="small"
              sx={iconButtonSx}
              disabled={disableMetricsButtons}
              onClick={() => clickLiveDayLaborButton()}
            >
              <PlayCircleOutlineIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip
            title={
              props.checkedMetricsToggle
                ? "After Action Report"
                : "Planned Action Report"
            }
          >
            <IconButton
              size="small"
              sx={iconButtonSx}
              disabled={disableMetricsButtons}
              onClick={() => clickDailyReportButton2()}
            >
              <ListAltIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        {props.guestReviewsEnabled &&
          props.actual_schedule_labor_day.length > 0 &&
          props.checkedMetricsToggle &&
          props.agg_column(props.actual_used_labor_vs_earned_day, "labor") !== 0 && (
            <Tooltip title="Guest Surveys Labor Overlay">
              <IconButton
                size="small"
                sx={iconButtonSx}
                onClick={() => clickGuestReviewButton()}
              >
                <RateReviewOutlinedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
      </div>
      <VisualChartModal
        open={props.laborModelEnabled && props.modelDataAvailable !== false && openChart}
        handleClose={handleCloseChart}
        forecasted_labor_day={props.forecasted_labor_day}
        actual_schedule_labor_day={props.actual_schedule_labor_day}
        calculated_earned_labor_day={props.calculated_earned_labor_day}
        actual_used_labor_vs_earned_day={props.actual_used_labor_vs_earned_day}
        actual_schedule={props.actual_schedule}
        agg_column={props.agg_column}
        get_t_str={props.get_t_str}
        combine_data={props.combine_data}
        dow_default_operating_hours={props.dow_default_operating_hours}
        day_operating_hours={props.day_operating_hours}
        date_name={props.date_name}
        earned_toggle={props.checkedMetricsToggle}
      />
      <VisualDailyReportModal2
        laborLawEnabled={props.laborLawEnabled}
        printHoursShownEnabled={props.printHoursShownEnabled}
        open={openDailyReport2}
        handleClose={handleCloseDailyReport2}
        forecasted_labor_day={props.forecasted_labor_day}
        actual_schedule_labor_day={props.actual_schedule_labor_day}
        calculated_earned_labor_day={props.calculated_earned_labor_day}
        actual_used_labor_vs_earned_day={props.actual_used_labor_vs_earned_day}
        actual_schedule={props.actual_schedule}
        agg_column={props.agg_column}
        get_t_str={props.get_t_str}
        combine_data={props.combine_data}
        dow_default_operating_hours={props.dow_default_operating_hours}
        day_operating_hours={props.day_operating_hours}
        date_name={props.date_name}
        date_str={props.date_str}
        store_team_member_weekly_info={props.store_team_member_weekly_info}
        daily_batch_guidance={props.daily_batch_guidance}
        daily_intraday_metrics={props.daily_intraday_metrics}
        actual_intraday_metrics={props.actual_intraday_metrics}
        forecast_sales={props.forecast_sales}
        calculate_daily_budget_score={props.calculate_daily_budget_score}
        calculate_intraday_coverage_score={
          props.calculate_intraday_coverage_score
        }
        calculate_letter={props.calculate_letter}
        calculate_color={props.calculate_color}
        daily_weather={props.daily_weather}
        role_types={props.role_types}
        role_names={props.role_names}
        start_qhnum={props.start_qhnum}
        schedule_day_end_qhnum={props.schedule_day_end_qhnum}
        actual_used_schedule={props.actual_used_schedule}
        earned_toggle={props.checkedMetricsToggle}
        store_id={props.store_id}
        refreshActualsForDate={props.refreshActualsForDate}
        pos_provider={props.pos_provider}
      />
      <GuestReviewOverlayModal
        open={openGuestReview}
        handleClose={handleCloseGuestReview}
        store_id={props.store_id}
        date_str={props.date_str}
        start_qhnum={props.start_qhnum}
        surveys={props.surveys}
        actual_used_schedule={props.actual_used_schedule}
        forecasted_labor_day={props.forecasted_labor_day}
        actual_schedule_labor_day={props.actual_schedule_labor_day}
        calculated_earned_labor_day={props.calculated_earned_labor_day}
        actual_used_labor_vs_earned_day={props.actual_used_labor_vs_earned_day}
        get_t_str={get_t_str}
        role_types={props.role_types}
      />
    </div>
  );
}

export default VisualButtonOptions2;
